import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import Cell from '../Cell'

const CellNumber = ({ unit, formatNumber, ...props }) => (
  <Cell
    align="center"
    {...props}
    render={number =>
      _.isNumber(number) ? (
        <>
          {formatNumber ? formatNumber(number, unit) : number}
          {unit && ` ${unit}`}
        </>
      ) : (
        'n/a'
      )
    }
  />
)

CellNumber.defaultProps = {
  formatNumber: undefined,
  unit: undefined,
}

CellNumber.propTypes = {
  formatNumber: PropTypes.func,
  unit: PropTypes.string,
}

export default CellNumber
